<template>
  <div class="audioProcess">
    <div class="audioFeedback">
      <div class="header">
        <div class="tips">{{ $t('audioSettings.audioFeedback') }}</div>
        <el-tooltip class="item" effect="dark" placement="top">
          <div slot="content">
            <p>{{ $t('audioSettings.feedbackBtnTips') }}</p>
          </div>
          <i class="iconfont icon-help2" style="color: #909090"></i>
        </el-tooltip>
      </div>
      <el-switch active-color="#03897b" inactive-color="#595959" v-model="State.showFeedbackBtn" @change="setFeedback"></el-switch>
      <span class="feedbackText">{{ $t('audioSettings.showFeedbackBtn') }}</span>
    </div>
    <!-- <div class="foot">
      <el-button size="small" class="saveBtn" @click="setAudioProcess()">{{ $t('audioSettings.refreshSave') }}</el-button>
    </div> -->
  </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      State: state => state
    })
  },
  created () {
    this.State.showFeedbackBtn = localStorage.getItem('showFeedbackBtn') === 'true'
  },
  methods: {
    setFeedback (val) {
      localStorage.setItem('showFeedbackBtn', val)
    }
  }
}
</script>
<style lang="less" scoped>
.audioFeedback {
  .header {
    display: flex;
    gap: 6px;
    align-items: center;
    margin-bottom: 16px;
  }
  .tips {
    color: #fff;
    font-size: 16px;
    font-weight: 500;
  }
  .feedbackText {
    color: #fff;
    margin-left: 8px;
  }
}
</style>
